import { useGetDashboardSummary } from '@myrentalmate/api-client';

import { okData } from './apiData';

/** The org's totals, shared by the dashboard and the list pages from one cached request. */
export function useDashboardSummary() {
  return okData(useGetDashboardSummary().data);
}
